import React from 'react';
import NavOptions from '../options/NavOptions';

const Navbar = () => {
  return (
    <div className="block md:hidden">
      <NavOptions />
    </div>
  );
};

export default Navbar;
